var _g, _g2, _g3, _g4, _path, _path2, _g5, _path3, _path4, _path5, _g6, _g7, _path6, _line, _polygon, _line2, _line3, _polygon2, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchulung(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.844 530.388",
    enableBackground: "new 0 0 841.844 530.388",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M272.117,171.891c0,48.807-31.686,69.607-70.774,69.607c-39.096,0-70.782-20.801-70.782-69.607 c0-48.808,46.928-107.147,70.782-107.147C228.323,64.745,272.117,123.084,272.117,171.891z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 197.04,
    y1: 305.627,
    x2: 197.04,
    y2: 122.619
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 197.04,
    y1: 143.62,
    x2: 216.595,
    y2: 128.095
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 197.04,
    y1: 192.225,
    x2: 177.488,
    y2: 175.019
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M565.72,386.492c0,0-0.631-91.521,85.872-146.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M601.974,386.492c0,0,24.809-49.685,85.873-68.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M609.978,277.917c10.829-14.303-0.915-30.686-16.265-34.123 C584.628,255.004,591.687,275.181,609.978,277.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M586.444,313.385c10.832-14.305-0.913-30.685-16.264-34.123 C561.097,290.472,568.159,310.65,586.444,313.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M583.862,313.382c8.475,15.411,31.016,15.647,42.598,6.401 C620.129,307.277,596.298,301.644,583.862,313.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M608.731,277.245c10.191,14.641,32.655,13.017,43.127,2.859 C644.136,268.179,619.774,264.537,608.731,277.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M630.572,255.869c19.407,4.076,33.796-10.701,32.629-24.176 C647.802,228.018,627.673,240.254,630.572,255.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M680.466,320.401c10.928,6.804,24.399,0.686,27.741-8.007C699.666,306.721,683.362,309.987,680.466,320.401 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M653.644,331.627c12.081-5.203,11.792-18.196,4.208-24.677 C648.038,310.853,644.055,324.707,653.644,331.627z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M632.987,347.896c9.412-8.289,4.133-20.484-5.528-24.488C619.694,329.833,621.265,344.033,632.987,347.896z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M632.709,350.009c4.416,10.896,19.577,12.413,28.144,6.896C657.64,348.095,642.059,342.86,632.709,350.009z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M655.675,332.318c4.414,10.897,19.577,12.412,28.144,6.895C680.607,330.404,665.026,325.17,655.675,332.318 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8EF93",
    d: "M651.592,402.194H505.297c0,0,12.726-30.319,44.525-13.536c34.983-22.205,68.699,4.237,68.699,4.237 S644.593,381.075,651.592,402.194z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#93DF27",
    d: "M359.292,181.155l11.75-11.855c1.465-1.479,1.132-4.184-0.743-6.041s-4.582-2.166-6.048-0.688 c0,0-1.828,1.85-2.512,2.535c-0.527,0.527-2.508,0.518-3.414-0.428c-0.876-0.914-0.757-2.686-0.229-3.215 c0.654-0.652,12.945-13.061,12.945-13.061c1.465-1.479,1.132-4.184-0.743-6.041c-1.875-1.857-4.582-2.166-6.048-0.688l-3.652,3.686 c0,0-1.796,1.545-3.369,0.674c-1.533-0.844-1.214-3.662-1.214-3.662l0.079-8.006c0.021-2.082-2.07-3.789-4.672-3.814 c-2.599-0.027-4.725,1.639-4.744,3.721c0,0-0.054,6.469-0.082,8.236c-0.029,1.768,0.348,3.119-1.146,3.826 c-0.899,0.424-2.153,0.389-2.79-0.25c-0.637-0.637-3.624-3.695-3.624-3.695c-1.456-1.486-4.165-1.193-6.05,0.654 c-1.887,1.848-2.232,4.549-0.777,6.037c0,0,12.279,12.531,12.518,12.768c0.236,0.236,1.302,1.77-0.094,3.164 c-1.383,1.385-2.723,0.412-2.939,0.195s-2.416-2.467-2.416-2.467c-1.59-1.621-4.406-1.438-6.291,0.41 c-1.887,1.848-2.126,4.66-0.537,6.281l11.505,11.736c0,0,1.487,1.666,0.18,3.139c-1.528,1.725-3.388,0.205-3.388,0.205 l-1.502-1.531c-1.572-1.604-4.373-1.406-6.258,0.441c-1.887,1.848-2.141,4.645-0.57,6.248l15.502,15.814 c0.051,0.051,0.105,0.096,0.16,0.145c0.049,0.053,0.096,0.109,0.148,0.16c1.874,1.857,4.721,2.025,6.355,0.375l16.147-16.291 c1.637-1.65,1.443-4.496-0.432-6.355c-1.875-1.857-4.722-2.025-6.358-0.373c0,0-0.86,0.871-1.374,1.385 c-0.513,0.514-2.099,1.086-3.441-0.254C357.659,182.809,359.292,181.155,359.292,181.155z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 351.632,
    y1: 219.868,
    x2: 351.632,
    y2: 135.811
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 336.217,146.524 351.632,161.688 366.872,146.524  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 336.217,166.805 351.632,181.969 366.872,166.805  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 336.217,186.93 351.632,202.094 366.872,186.93  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    d: "M598.882,293.411c0,22.11-17.924,17.935-40.033,17.935l0,0c-22.11,0-40.032,4.176-40.032-17.935V176.21 c0-22.109,17.922-18.032,40.032-18.032l0,0c22.109,0,40.033-4.077,40.033,18.032V293.411z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.174,
    y: 178.166,
    fill: "#FFFFFF",
    width: 75.349,
    height: 112.899
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 545.205,
    y1: 168.154,
    x2: 572.491,
    y2: 168.154
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M564.981,300.77c0,3.387-2.746,6.133-6.133,6.133c-3.387,0-6.134-2.746-6.134-6.133c0-3.387,2.747-6.133,6.134-6.133 C562.235,294.637,564.981,297.383,564.981,300.77z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8EF93",
    d: "M341.975,306.382c0,0-2.893,7.779-2.893,21.438c0,13.656,2.893,26.797,2.893,26.797H165.699v-48.234H341.975 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#684B93",
    d: "M346.278,361.55l1.535,45.85H171.537c0,0,2.894-8.443,2.894-22.926 c0-15.227-2.894-24.116-2.894-24.116L346.278,361.55z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079483801322574052800000004415884057659606413_",
    d: "M346.278,361.55l1.535,45.85H171.537 c0,0,2.894-8.443,2.894-22.926c0-15.227-2.894-24.116-2.894-24.116L346.278,361.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021121290795770243240000004642921223939421076_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079483801322574052800000004415884057659606413_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000021121290795770243240000004642921223939421076_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M314.711,179.241L46.447,447.498 M319.095,185.377L50.83,453.639 M325.456,189.987L57.189,458.247 M329.838,196.125L61.575,464.387  M335.91,200.445L67.644,468.703 M340.294,206.58L72.029,474.843 M346.655,211.187L78.389,479.448 M351.038,217.326L82.774,485.586  M356.413,221.812L88.15,490.074 M360.798,227.951L92.535,496.213 M367.159,232.558L98.896,500.82 M371.541,238.696 l-268.26,268.259 M377.612,243.014L109.349,511.275 M381.997,249.152L113.732,517.413 M388.359,253.76L120.096,522.021  M392.741,259.899l-268.264,268.26 M398.487,263.849l-268.263,268.26 M402.872,269.988L134.61,538.247 M409.234,274.595 L140.971,542.855 M413.62,280.732L145.351,548.993 M419.687,285.05L151.424,553.312 M424.073,291.188L155.81,559.449  M430.434,295.797l-268.264,268.26 M434.819,301.934L166.555,570.196 M440.193,306.423L171.93,574.682 M444.576,312.56 L176.312,580.816 M450.935,317.166L182.674,585.429 M455.321,323.306L187.058,591.563 M461.39,327.625l-268.26,268.259  M465.774,333.762l-268.263,268.26 M472.14,338.369L203.873,606.632 M476.521,344.506L208.258,612.767"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2.893,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M349.12,306.382c0,0-163.759,0-169.714,0c-10.193,0-10.787,48.234,0,48.234c6.549,0,169.714,0,169.714,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    stroke: "#684B93",
    strokeWidth: 2.893,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M116.879,306.382c0,0,74.436,0,62.527,0c-11.91,0-11.91,48.234,0,48.234c11.908,0-62.527,0-62.527,0V306.382z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    d: "M434.71,360.417l-39.639,0.133H162.732c-0.553,0-1,0.447-1,1c0,0.553,0.447,1,1,1h173.882 c5.32,0,8.613,12,8.613,23.118c0,5.702-0.803,10.903-2.26,14.648c-1.08,2.775-3.061,6.084-6.354,6.084H162.732c-0.553,0-1,0.447-1,1 c0,0.553,0.447,1,1,1h200.677c0.496,0.106,0.998,0.167,1.51,0.165l49.881-0.165h17.736c0.105,0,0.201-0.029,0.297-0.06l2.039-0.007 c7.088-0.024,12.799-10.769,12.756-24.004C447.583,371.101,441.8,360.394,434.71,360.417z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 171.49,303.844 150.153,303.844 145.352,260.636 174.692,260.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 179.492,260.636 141.086,260.636 142.686,248.902 177.891,248.902  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2A4C8",
    points: "212.58,339.204 348.974,339.204 312.76,270.407 341.728,270.407 304.316,212.471 324.833,212.471  280.772,142.469 236.429,212.471 262.07,212.471 225.858,270.407 263.274,270.407  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 283.951,
    y1: 413.62,
    x2: 283.951,
    y2: 222.788
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 261.272,
    y1: 247.034,
    x2: 283.951,
    y2: 273.624
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 307.415,
    y1: 297.87,
    x2: 283.951,
    y2: 318.204
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#684B93",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M535.822,382.16c0,0-0.873-128.271-0.873-140.934s-0.982-14.168-12.706-14.512c-33.231-0.977-129.665-4.887-201.665-7.167 c-10.746-0.34-13.032,1.951-13.032,14.661c0,26.063,0.326,156.706,0.326,156.706s2.596,26.611,2.596,31.481 s5.298,7.153,23.793,5.985c30.95-1.955,260.368-15.929,272.036-16.615c5.538-0.326,7.549-5.387-1.303-8.145 C585.121,397.429,535.822,382.16,535.822,382.16z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FCFCFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 306.678,
    y1: 390.696,
    x2: 536.542,
    y2: 381.247
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029733085652436471420000003355778114432849059_",
    gradientUnits: "userSpaceOnUse",
    x1: 512.5824,
    y1: 173.7571,
    x2: 357.18,
    y2: 395.6209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    style: {
      stopColor: "#684B93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    style: {
      stopColor: "#280A3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#1F1227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9749,
    style: {
      stopColor: "#1A171B"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000029733085652436471420000003355778114432849059_)",
    stroke: "#684B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 321.398,233.294 523.23,240.785 524.91,369.569 322.752,375.436 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 336.068,
    y1: 397.923,
    x2: 533.325,
    y2: 390.022
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 337.124,
    y1: 404.894,
    x2: 542.891,
    y2: 394.967
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 424.094,408.446 478.076,405.916 490.307,413.929 431.685,417.303 "
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M498.411,254.875c0,0,3.762-5.34,8.637-5.34 s6.121,6.432,12.137,6.432c6.018,0,7.678-6.432,12.553-6.432s7.262,6.432,12.447,6.432c5.188,0,7.365-6.432,12.24-6.432 s6.949,6.432,12.24,6.432c5.291,0,6.742-6.432,12.656-6.432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M473.958,269.553c0,0,3.761-5.34,8.636-5.34 s6.121,6.432,12.137,6.432c6.016,0,7.676-6.432,12.553-6.432c4.875,0,7.26,6.432,12.447,6.432s7.365-6.432,12.24-6.432 c4.877,0,6.951,6.432,12.24,6.432c5.291,0,6.744-6.432,12.656-6.432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#95DD3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M473.958,283.536c0,0,3.761-5.34,8.636-5.34 s6.121,6.432,12.137,6.432c6.016,0,7.676-6.432,12.553-6.432c4.875,0,7.26,6.432,12.447,6.432s7.365-6.432,12.24-6.432 c4.877,0,6.951,6.432,12.24,6.432c5.291,0,6.744-6.432,12.656-6.432"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchulung);
export default __webpack_public_path__ + "static/media/schulung.ca10faf11862180f06da74d6b7cc25f4.svg";
export { ForwardRef as ReactComponent };